import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=3151d531&scoped=true"
import script from "./BookingDetail.vue?vue&type=script&lang=js"
export * from "./BookingDetail.vue?vue&type=script&lang=js"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=3151d531&prod&lang=less&scoped=true"
import style1 from "./BookingDetail.vue?vue&type=style&index=1&id=3151d531&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151d531",
  null
  
)

export default component.exports